import lenisScroll from './_components/lenisScroll';
import parallax from './_components/parallax';
import philosophy from './_components/philosophy';
import preloader from './_components/preloader';
import splide from './_components/splide';
import animate from './_components/animate';
import lazy from './_components/lazy';
import smoothScroll from './_components/smoothScroll';
import visual from './_components/visual';
import scrollAction from './_components/scrollAction';
import counter from './_components/counter';
import charts from './_components/chart';
import hamburger from './_components/hamburger';

gsap.registerPlugin(ScrollTrigger);

// 先に「プレローダーに依存しない」初期化は走らせてもOK
splide.init();
lazy.init();
smoothScroll.init();
philosophy.init();
lenisScroll.init();
scrollAction.init();
animate.init();
counter.init();
hamburger.init();
parallax.init();

charts.initBarChart();
charts.initPieChart();
charts.initPieChartMaleToFemaleRatio();

// プレローダーは 1 回だけ。完了後にビジュアル開始
(async () => {
  try {
    await preloader.init({ timeoutMs: 5000 });
  } catch (e) {
    console.error(e);
  }
  visual.start();
})();
